var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"orders-list"},_vm._l((_vm.orders),function(order){return _c('li',{key:order.id,staticClass:"orders-list__item"},[_c('order-item',{attrs:{"order":order,"shop-id":_vm.shopId,"url-query":_vm.urlQuery,"checked":_vm.isChecked(order.id),"context":_vm.context},on:{"checked":_vm.handleChecked}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }